module.exports = __webpack_public_path__ + "assets/img/golden-sword.ce762878.png";